import { render, staticRenderFns } from "./OtherUserGroupMemberDetailModal.vue?vue&type=template&id=3fda125d&scoped=true&lang=pug"
import script from "./OtherUserGroupMemberDetailModal.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupMemberDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupMemberDetailModal.vue?vue&type=style&index=0&id=3fda125d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda125d",
  null
  
)

export default component.exports